import "reflect-metadata";
import { QuoteService } from 'quote-domain-core';
import { container } from 'tsyringe';
import { PriceEngineConfigCalculator } from './price-engine-config-calculator';

export class PriceEngineManager {
    getCorridors(
        quoteService: QuoteService,
        referential: any,
        referentialService: any,
        countryIsoCode: string,
        role: string,
        region: string
    ): QuoteService {
        const calculator = container.resolve(PriceEngineConfigCalculator)
            .getCalculatorInstance(countryIsoCode, role, quoteService.code, region, quoteService, referential, referentialService);
        if (calculator) {
            calculator.execute();
        }
        return quoteService;
    }
}
